import { Row, Text } from 'components';
import { normalizeDate } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin 0 10px 10px;

  ${(props) =>
    props.isSender &&
    `
    flex-direction: row-reverse;
  `}
`;

const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.isSender ? 'flex-end' : 'flex-start')};
  max-width: 80%;
`;

const MsgContainer = styled.div`
  border: 1px solid #ddd;
  display: flex;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  width: fit-content;
  width: 100%;
  ${(props) =>
    !props.isSender ? `border-top-right-radius: 10px;` : `border-top-left-radius: 10px;`}
`;

const ChatMsg = ({ data, currentUser }) => {
  const { createdAt, sender, body } = data,
    { t } = useTranslation(),
    isSender = sender === currentUser;

  return (
    <Wrapper isSender={isSender}>
      <InfoCol isSender={isSender}>
        <Row style={{ justifyContent: isSender ? 'flex-end' : 'flex-start' }}>
          <Text weight="500" marg="0 0 5px">
            {sender}, {normalizeDate(createdAt, 'Default', t)}
          </Text>
        </Row>

        <MsgContainer isSender={isSender}>
          <Text>{body}</Text>
        </MsgContainer>
      </InfoCol>
    </Wrapper>
  );
};

export default ChatMsg;
